import * as Yup from 'yup';
import React, { useState } from 'react';
import { Form, Formik, FormikProps } from 'formik';
import { Col, Row } from 'react-bootstrap';
import { Input, SalvButton, SalvModal, Size } from '@salvapp/ui-components';
import { setRefresh } from '../table/redux/tablesReducer';
import { useDispatch } from 'react-redux';
import { finalRiskApi } from '../apis';

export interface EditFinalRiskOverrideReasonFormValues {
  overrideReasonHandle: string;
  reason: string;
  description: string;
}

const validationSchema = Yup.object().shape({
  reason: Yup.string().required('Required'),
  description: Yup.string().required('Required'),
});

export const EditFinalRiskOverrideReasonModal = ({
  overrideReasonHandle,
  reason,
  description,
}: EditFinalRiskOverrideReasonFormValues) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const submit = async (values: EditFinalRiskOverrideReasonFormValues) => {
    await finalRiskApi.editOverrideReason({
      handle: overrideReasonHandle,
      internalApiAddFinalRiskOverrideReason: { ...values },
    });
    setShowModal(false);
    dispatch(setRefresh({ name: 'riskOverrideReasons', shouldRefresh: true }));
  };
  const archive = async () => {
    await finalRiskApi.archiveOverrideReason({ handle: overrideReasonHandle });
    setShowModal(false);
    dispatch(setRefresh({ name: 'riskOverrideReasons', shouldRefresh: true }));
    dispatch(setRefresh({ name: 'archivedRiskOverrideReasons', shouldRefresh: true }));
  };

  return (
    <>
      <div>
        <SalvButton variant='secondary' onClick={() => setShowModal(true)} label='Edit' size={Size.SMALL} />
      </div>
      <Formik
        initialValues={{
          overrideReasonHandle,
          reason,
          description,
        }}
        onSubmit={submit}
        validationSchema={validationSchema}
      >
        {({ values, isSubmitting, setFieldValue, isValid }: FormikProps<EditFinalRiskOverrideReasonFormValues>) => (
          <SalvModal show={showModal} onHide={() => setShowModal(false)}>
            <Form>
              <SalvModal.Header closeButton>Edit reason</SalvModal.Header>
              <SalvModal.Body>
                <Row>
                  <Col md={12}>
                    <div className='row'>
                      <div className='col'>
                        <Input
                          name='reason'
                          label='Reason'
                          placeholder='Enter here'
                          value={values.reason}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFieldValue('reason', e.target.value)}
                        />
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col mt-3'>
                        <Input
                          name='description'
                          label='Description'
                          placeholder='Enter here'
                          value={values.description}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            setFieldValue('description', e.target.value)
                          }
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </SalvModal.Body>
              <SalvModal.Footer>
                <SalvButton variant='danger-outline' onClick={archive} label='Archive' />
                <SalvButton variant='muted' onClick={() => setShowModal(false)} label='Close' />
                <SalvButton disabled={isSubmitting || !isValid} type='submit' variant='primary' label='Save' />
              </SalvModal.Footer>
            </Form>
          </SalvModal>
        )}
      </Formik>
    </>
  );
};
